/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { Facebook, Adwords as AdwordsNetwork } from 'cio/components/segments/create-audience/select-network';

interface AdwordsArgs {
  isSelected?: boolean;
  network: Facebook | AdwordsNetwork;
  adAccountId: string | null;
  onConnect: (event: Event) => unknown;
}

export default class Adwords extends Component<AdwordsArgs> {}
